module.exports = __webpack_public_path__ + "static/media/2.56e1ab05.jpg";